import * as tslib_1 from "tslib";
import resetNewFolderViewState from '../mutators/resetNewFolderViewState';
import setNewFolderInvalidState from '../mutators/setNewFolderInvalidState';
import setNewFolderText from '../mutators/setNewFolderText';
import menuStore from '../store/store';
import isFolderNameValid from '../utils/isFolderNameValid';
import { observer } from 'mobx-react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { getRTL } from 'office-ui-fabric-react/lib/Utilities';
import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import strings from 'owa-strings/owa-mail-strings';
var styles = require('./NewFolderMenuItem.scss');
var classNames = require('classnames/bind').bind(styles);
var NewFolderMenuItem = /** @class */ (function (_super) {
    tslib_1.__extends(NewFolderMenuItem, _super);
    function NewFolderMenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCreateNewMenu = function () {
            var findText = menuStore.findText;
            var ariaLabel = strings.moveToFolderCreateNewAriaLabel;
            return (React.createElement("div", { "aria-label": ariaLabel, className: classNames(styles.newFolderMenuItemContainer, _this.props.containerClass), title: strings.moveToFolderCreateNewTooltip, "data-is-focusable": true, onKeyDown: function (ev) { return _this.onKeyDownOnCreateNewFolder(ev, findText); }, onClick: function (ev) { return _this.onCreateNewFolderClicked(ev, findText); }, role: 'menuitem' },
                _this.renderCreateNewIcon(),
                _this.renderCreateNew()));
        };
        _this.renderNewFolderEditMenu = function () {
            var newFolderViewState = menuStore.newFolderViewState;
            var newFolderInternalContainerClass = classNames(styles.newFolderMenuItemContainerInternal, { isInvalid: newFolderViewState.isInvalid });
            return (React.createElement("div", { className: styles.newFolderMenuItemContainer, "data-is-focusable": true, role: 'menuitem' },
                React.createElement("div", { className: newFolderInternalContainerClass },
                    _this.renderCreateNewIcon(),
                    _this.renderNewFolderTextField())));
        };
        /**
         * Render the text field to input the new folder name
         */
        _this.renderNewFolderTextField = function () {
            return (React.createElement(TextField, { autoFocus: true, borderless: true, componentRef: function (ref) { return (_this.textField = ref); }, className: styles.newFolderTextField, inputClassName: styles.newFolderTextInput, onChanged: _this.onNewFolderTextChanged, onKeyDown: _this.onKeyDownOnNewTextField, placeholder: strings.moveToFolderAddFolderNameText, value: menuStore.newFolderViewState.folderText }));
        };
        /**
         * Store text
         */
        _this.onNewFolderTextChanged = function (text) {
            setNewFolderText(text.trim());
        };
        /**
         * Handler key down event on the TextField
         * OnEnter- call commit new folder (calls create from props)
         * OnEscape- resetNewFolderViewState, which will dismiss *only* the new folder menu
         */
        _this.onKeyDownOnNewTextField = function (event) {
            switch (event.keyCode) {
                case 37 /* left */:
                    // Stop propagation on left key when user typed in text field to prevent dismiss the folder submenu
                    if (!getRTL() && _this.textField.value) {
                        event.stopPropagation();
                    }
                    break;
                case 39 /* right */:
                    // Stop propagation on right key for RTL when user typed in text field to prevent dismiss the folder submenu
                    if (getRTL() && _this.textField.value) {
                        event.stopPropagation();
                    }
                    break;
                case 13 /* enter */:
                    _this.commitNewFolder(_this.textField.value, 'NewFolderItem');
                    break;
                case 27 /* escape */:
                    event.stopPropagation();
                    resetNewFolderViewState();
                    break;
            }
        };
        /**
         * Render simple icon for a create new menu
         */
        _this.renderCreateNewIcon = function () {
            return React.createElement(Icon, { className: styles.newFolderIcon, iconName: "FabricFolder" /* FabricFolder */ });
        };
        /**
         * On key down on create new folder menu
         */
        _this.onKeyDownOnCreateNewFolder = function (ev, findText) {
            if (ev.keyCode === 13 /* enter */) {
                ev.stopPropagation();
                _this.commitNewFolder(findText, 'SearchCreateNew');
            }
        };
        /**
         * On click on create new folder menu
         */
        _this.onCreateNewFolderClicked = function (ev, findText) {
            ev.stopPropagation();
            _this.commitNewFolder(findText, 'SearchCreateNew');
        };
        _this.commitNewFolder = function (folderName, actionSource) {
            if (isFolderNameValid(folderName)) {
                _this.props.createNew(folderName, actionSource);
                resetNewFolderViewState();
            }
            else {
                setNewFolderInvalidState(true /* isInvalid */);
            }
        };
        return _this;
    }
    NewFolderMenuItem.prototype.render = function () {
        var newFolderViewState = menuStore.newFolderViewState;
        // Case 1: Show Create New
        // Case 2: Show New Folder when in edit mode
        // Resetting newFolderViewState to null is also a value change and causes
        // re-render. Therefore check for null and early return.
        if (this.props.isEditMode) {
            if (newFolderViewState) {
                return this.renderNewFolderEditMenu();
            }
            else {
                return null;
            }
        }
        else {
            return this.renderCreateNewMenu();
        }
    };
    /**
     * Render the folder find text and the (Create new) text
     */
    NewFolderMenuItem.prototype.renderCreateNew = function () {
        var findText = menuStore.findText;
        return (React.createElement("div", { className: styles.createNewTextContainer },
            React.createElement("div", { className: styles.createNewFolderMatchText }, '"' + findText + '"'),
            React.createElement("div", { className: styles.createNewFolderText },
                "\u00A0",
                strings.moveToFolderCreateNewText)));
    };
    NewFolderMenuItem = tslib_1.__decorate([
        observer
    ], NewFolderMenuItem);
    return NewFolderMenuItem;
}(React.Component));
export default NewFolderMenuItem;
//# sourceMappingURL=NewFolderMenuItem.js.map